

import { Label } from "../../components/atoms/RTCC/label";
import "../../resources/css/search/search.css";
import "../../resources_membership_hotel/css/common/common.css";

export const ModalOptionForm = (props) => {
    const { divClass, title, onClick, text, id } = props;

    return (
        <div className={divClass}>
            <Label className={"modalLabel "+props.labelClass} label={title} />
            <div className={"modalOptionStyle "+props.dateClass} onClick={onClick} id={id}>
                {text}
            </div>
        </div>
    );
};